import CityServicePage from "@/pages/city-service/CityServicePage";
import { mississaugaGasLine } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={mississaugaGasLine} />; }
